/**
 * EVO — mavzu almashtirgichi.
 *
 * ╔══════════════════════════════════════════════════════════════════════════╗
 * ║ NIMA UCHUN BU TUGMA UMUMAN PAYDO BO'LDI                                  ║
 * ║                                                                          ║
 * ║ Ilgari mavzuni WINDOWS tanlardi (`prefers-color-scheme`) va ilova ichida ║
 * ║ uni o'zgartiradigan hech narsa yo'q edi. Natijasi: tizimi qorong'i       ║
 * ║ turgan odam ERP ni hech qachon oq holda ko'ra olmasdi va buni tuzatish   ║
 * ║ uchun butun Windows sozlamasini almashtirishi kerak edi.                 ║
 * ║                                                                          ║
 * ║ Endi standart holat — OQ, tanlov esa shu tugmada va u brauzerda          ║
 * ║ saqlanadi (`lib/theme.ts`).                                              ║
 * ║                                                                          ║
 * ║ ┌─ NEGA UCHINCHI «TIZIMGA ERGASH» VARIANTI YO'Q ──────────────────────┐  ║
 * ║ │ U eng «to'g'ri» yechimga o'xshaydi va aynan hozirgi muammoni        │  ║
 * ║ │ qaytarib olib kelardi: ekran o'z-o'zidan qorong'i bo'lib qolsa,     │  ║
 * ║ │ foydalanuvchi buni ilovaning xatosi deb o'ylaydi. Ikki holat        │  ║
 * ║ │ bor — nimani bossa, o'sha turadi.                                   │  ║
 * ║ └──────────────────────────────────────────────────────────────────────┘ ║
 * ╚══════════════════════════════════════════════════════════════════════════╝
 *
 * Til almashtirgichdan farqli o'laroq bu YAKKA tugma, segment emas: variant
 * ikkita va ikkita segment «yoqilgan/o'chirilgan» tugmadan ko'ra ko'proq joy
 * egallardi. Panelda joy tor (`topbar.tsx` izohi).
 */
import { useState, type ReactNode } from 'react';
import { applyTheme, readTheme, saveTheme, type Theme } from '../../lib/theme';
import { useT } from '../../lib/i18n-context';

export function ThemeSwitch(): ReactNode {
  const t = useT();
  /*
   * Boshlang'ich qiymat `localStorage` dan O'QILADI, `'light'` deb
   * qotirilmaydi: mavzu `main.tsx` da allaqachon qo'yilgan va bu yerda
   * `'light'` yozilsa, qorong'i mavzudagi foydalanuvchi ekranida quyosh
   * belgisi turardi — ya'ni tugma yolg'on holat ko'rsatardi.
   */
  const [theme, setTheme] = useState<Theme>(() => readTheme());

  const next: Theme = theme === 'dark' ? 'light' : 'dark';

  const toggle = (): void => {
    applyTheme(next);
    saveTheme(next);
    setTheme(next);
  };

  return (
    <button
      type="button"
      onClick={toggle}
      /*
       * `title` va `aria-label` bir xil va ikkalasi ham KEYINGI holatni
       * aytadi («qorong'i mavzuga o'tish»), joriysini emas. Belgi joriy
       * holatni ko'rsatadi, matn esa bosilganda nima bo'lishini — ikkalasi
       * bir narsani takrorlasa, tugma nima qilishi noaniq qolardi.
       */
      title={t(next === 'dark' ? 'nav.theme.toDark' : 'nav.theme.toLight')}
      aria-label={t(next === 'dark' ? 'nav.theme.toDark' : 'nav.theme.toLight')}
      /*
       * Ranglar `chrome-*` dan — tugma KORPUS ustida turadi, oq sirtda emas.
       *
       * ⚠️ Kulgili tuzoq: aynan MAVZU tugmasining o'zi mavzuga bog'liq
       * ranglarda turgan edi (`text-ink-muted`). Yuqori panel jadega
       * o'tgach u yorug' mavzuda ko'rinmay qoldi — ya'ni foydalanuvchi
       * mavzuni qaytarish uchun bosishi kerak bo'lgan tugma yo'qolardi.
       * `chrome-*` esa mavzudan qat'iy nazar bir xil, shuning uchun bu
       * yerda `dark:` variant YO'Q.
       */
      className="flex size-9 shrink-0 items-center justify-center rounded-lg text-chrome-muted transition-colors hover:bg-chrome-2 hover:text-chrome-ink motion-reduce:transition-none"
    >
      {theme === 'dark' ? (
        /* Oy — hozir qorong'i. */
        <svg
          viewBox="0 0 24 24"
          aria-hidden="true"
          className="size-5"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M20 14.5A8.5 8.5 0 0 1 9.5 4a8.5 8.5 0 1 0 10.5 10.5Z" />
        </svg>
      ) : (
        /* Quyosh — hozir yorug'. */
        <svg
          viewBox="0 0 24 24"
          aria-hidden="true"
          className="size-5"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="4" />
          <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
        </svg>
      )}
    </button>
  );
}
